import {
  tenantApiRoutes,
  NotificationResponse,
} from '@repo/contracts/tenant-api';

import { tenantApi } from '@/redux/api/tenant-api';

/**
 * RTK Query API slice for notification endpoints
 */
export const notificationsApi = tenantApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    /**
     * GET /notifications/users/:userId - List all notifications for user
     */
    getNotifications: builder.query<NotificationResponse[], string>({
      query: (userId) => tenantApiRoutes.notifications.listByUser(userId),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: 'Notification' as const,
                id,
              })),
              { type: 'Notification', id: 'LIST' },
            ]
          : [{ type: 'Notification', id: 'LIST' }],
    }),

    /**
     * PATCH /notifications/:id/read - Mark notification as read
     */
    markNotificationAsRead: builder.mutation<NotificationResponse, string>({
      query: (id) => ({
        url: tenantApiRoutes.notifications.markAsRead(id),
        method: 'PATCH',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Notification', id },
        { type: 'Notification', id: 'LIST' },
      ],
    }),

    /**
     * PATCH /notifications/read-all - Mark all notifications as read
     */
    markAllNotificationsAsRead: builder.mutation<void, void>({
      query: () => ({
        url: tenantApiRoutes.notifications.markAllAsRead(),
        method: 'PATCH',
      }),
      invalidatesTags: [{ type: 'Notification', id: 'LIST' }],
    }),

    /**
     * DELETE /notifications/:id - Delete notification
     */
    deleteNotification: builder.mutation<void, string>({
      query: (id) => ({
        url: tenantApiRoutes.notifications.delete(id),
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Notification', id },
        { type: 'Notification', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation,
  useDeleteNotificationMutation,
} = notificationsApi;
